export const Bio = {
  name: 'Tristan Nguyen',
  roles: ['Software Engineering', 'Backend Development', 'Payments Engineering', 'System Design'],
  description:
    'I am a Computer Science & Design student at SUTD and a backend-focused software engineer with experience building payment systems, resilient APIs, and scalable data workflows. I enjoy designing reliable services, optimizing databases and infrastructure, and turning complex product requirements into production-ready systems.',
  github: 'https://github.com/TristanNguyen04',
  resume: 'https://drive.google.com/file/d/1OzXsiMOK8PVJkd1Oznq0R6wEJmv213_S/view?usp=sharing',
  linkedin: 'https://www.linkedin.com/in/dungquocnguyen/',
};

export const skills = [
  {
    title: 'Frontend',
    skills: [
      {
        name: 'HTML',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg',
      },
      {
        name: 'CSS',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg',
      },
      {
        name: 'JavaScript',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg',
      },
      {
        name: 'TypeScript',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg',
      },
      {
        name: 'Next.js',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg',
      },
      {
        name: 'React.js',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg',
      },
      {
        name: 'Bootstrap',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/bootstrap/bootstrap-original.svg',
      },
      {
        name: 'Node.js',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg',
      },
    ],
  },
  {
    title: 'Backend',
    skills: [
      {
        name: 'Java',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg',
      },
      {
        name: 'TypeScript',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg',
      },
      {
        name: 'JavaScript',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg',
      },
      {
        name: 'Python',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg',
      },
      {
        name: 'Go',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/go/go-original.svg',
      },
      {
        name: 'C',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/c/c-original.svg',
      },
      {
        name: 'C++',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg',
      },
      {
        name: 'C#',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/csharp/csharp-original.svg',
      },
      {
        name: 'Spring',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/spring/spring-original.svg',
      },
      {
        name: 'NestJS',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nestjs/nestjs-original.svg',
      },
      {
        name: 'Express.js',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg',
      },
      {
        name: 'Flask',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flask/flask-original-wordmark.svg',
      },
      {
        name: 'ASP.NET',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dot-net/dot-net-original.svg',
      },
      {
        name: 'PostgreSQL',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original-wordmark.svg',
      },
      {
        name: 'MySQL',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original-wordmark.svg',
      },
      {
        name: 'SQLite',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sqlite/sqlite-original-wordmark.svg',
      },
      {
        name: 'MongoDB',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original-wordmark.svg',
      },
      {
        name: 'Neo4j',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/neo4j/neo4j-original.svg',
      },
      {
        name: 'Cassandra',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cassandra/cassandra-original.svg',
      },
      {
        name: 'Firebase',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original-wordmark.svg',
      },
      {
        name: 'Redis',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg',
      },
    ],
  },
  {
    title: 'DevOps',
    skills: [
      {
        name: 'AWS',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg',
      },
      {
        name: 'GCP',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/googlecloud/googlecloud-original-wordmark.svg',
      },
      {
        name: 'Docker',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original-wordmark.svg',
      },
      {
        name: 'Kubernetes',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-original.svg',
      },
      {
        name: 'Kafka',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/apachekafka/apachekafka-original.svg',
      },
      {
        name: 'NGINX',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nginx/nginx-original.svg',
      },
    ],
  },
  {
    title: 'Machine Learning',
    skills: [
      {
        name: 'Python',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg',
      },
      {
        name: 'TensorFlow',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original.svg',
      },
      {
        name: 'PyTorch',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original.svg',
      },
      {
        name: 'scikit-learn',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/scikitlearn/scikitlearn-original.svg',
      },
    ],
  },
  {
    title: 'Others',
    skills: [
      {
        name: 'GitLab',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/gitlab/gitlab-original.svg',
      },
      {
        name: 'GitHub',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg',
      },
      {
        name: 'GitHub Actions',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/githubactions/githubactions-original.svg',
      },
      {
        name: 'Datadog',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/datadog/datadog-original.svg',
      },
      {
        name: 'Optuna',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg',
      },
      {
        name: 'Vercel',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vercel/vercel-original.svg',
      },
      {
        name: 'Linux',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/linux/linux-original.svg',
      },
      {
        name: 'Ubuntu',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ubuntu/ubuntu-original-wordmark.svg',
      },
      {
        name: 'Postman',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg',
      },
      {
        name: 'Figma',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg',
      },
      {
        name: 'Jira',
        image: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg',
      },
      {
        name: 'Confluence',
        image:
          'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/confluence/confluence-original.svg',
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmTR6sqnRbYNuHmfG2GLtXBKxzAsrzrt3LyyZR5AHfNpS8',
    role: 'Software Engineer Intern',
    company: 'ShopBack',
    date: 'May 2026 - Sep 2026',
    desc: 'On the Payments Supply & Checkout team, built pre-authorization, account-linking, and 3DS CIT verification APIs across 4 services to launch a bank-partner tokenized-payment method, including idempotent hold, void, and capture flows. Migrated a production-critical, multi-partner rewards platform from JavaScript to TypeScript with AI-assisted development tools, traffic mirroring, risk-ranked allowlists, percentage-based ramp-ups, and PM-reviewed post-release metrics, delivering a zero-downtime cutover. Introduced resilient Redis caching for payment-processing and merchant-loyalty services using TTL jitter, circuit breakers, single-flight coalescing, and fail-closed guardrails, reducing command error rates by 37.6% and 28.9% during seasonal-sale traffic 28% above normal. Engineered a fail-fast payment-eligibility workflow for a checkout path handling 1.8-2.3M monthly transactions, cutting platform-caused payment failures by 73% in September 2026 and achieving a 99.9%+ payment success rate excluding user-caused declines.',
    skills: [
      'TypeScript',
      'NestJS',
      'Redis',
      'PostgreSQL',
      'Amazon Web Services',
      'Docker',
      'Kubernetes',
      'Kafka',
      'Datadog',
      'Distributed Systems',
      'Event-Driven Architecture',
      'AI Coding-Agent Pipelines',
      'Claude Code',
      'GitLab',
    ],
  },
  {
    id: 1,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmTR6sqnRbYNuHmfG2GLtXBKxzAsrzrt3LyyZR5AHfNpS8',
    role: 'Software Engineer Intern',
    company: 'ShopBack',
    date: 'Aug 2025 - Jan 2026',
    desc: 'Reduced inter-service p99 latency from 350ms to under 73ms (a 79.1% reduction) across 4 microservices by replacing HTTP calls with direct function calls via dependency inversion in a NestJS monorepo DI container. Delivered real-time offer personalization at payment checkout using a transaction-context-aware targeting engine with PostGIS geographic filtering, driving a 2.5% GMV uplift across 1.8M monthly transactions. Increased payment completion reliability and cut post-3DS webhook failures by 10% by redesigning webhook handling with asynchronous, idempotent event processing. Eliminated manual reconciliation effort for 1M+ monthly transactions by engineering a cross-regional settlement-report pipeline unifying payment data from 4 regional sources.',
    skills: [
      'TypeScript',
      'NestJS',
      'RESTful API',
      'PostgreSQL',
      'PostGIS',
      'DB Migration',
      'Amazon Web Services',
      'Docker',
      'Kubernetes',
      'Datadog',
      'Cursor',
      'In-house MCP',
      'Claude Code',
      'GitLab',
    ],
  },
  {
    id: 2,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmSLZ1UMAEnnc8atxDhnh4NJ582K9pz5yXbcpgHzMnM7P2',
    role: 'Teaching Assistant @ Data Driven World',
    company: 'Singapore University of Technology and Design',
    date: 'May 2024 - Aug 2025',
    desc: 'As a Teaching Assistant for 10.020 Data Driven World, I supported over 100 students across three weekly lab sessions by guiding them through Python programming, algorithm design, and foundational machine learning techniques such as linear and logistic regression. I provided technical feedback on assignments and projects, helped students debug code, and reinforced core concepts in data structures and object-oriented design. I also collaborated with instructors and fellow TAs to develop lab exercises and ensure smooth project execution using tools like GitHub, NumPy, pandas, and scikit-learn.',
    skills: [
      'Assistant Teaching',
      'Python',
      'NumPy',
      'pandas',
      'scikit-learn',
      'Algorithm Design',
      'Machine Learning',
      'GitHub',
    ],
  },
  {
    id: 3,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmSLZ1UMAEnnc8atxDhnh4NJ582K9pz5yXbcpgHzMnM7P2',
    role: 'Teaching Assistant @ Modelling & Analysis (Calculus 2)',
    company: 'Singapore University of Technology and Design (SUTD)',
    date: 'Sep 2024 - Dec 2024',
    desc: 'Provided academic support to 46 students through weekly tutorial sessions, simplifying complex calculus topics such as differential equations and series convergence. Conducted supplementary sessions to enhance problem-solving skills for students, ensuring a deeper understanding of key concepts.',
    skills: [
      'Higher Education Teaching',
      'Assistant Teaching',
      'Calculus',
      'Differential Equations',
    ],
  },
  {
    id: 4,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmSLZ1UMAEnnc8atxDhnh4NJ582K9pz5yXbcpgHzMnM7P2',
    role: 'Undergraduate Researcher @ Data-driven Assessment of ASEAN Street Space Qualities',
    company: 'Singapore University of Technology and Design (SUTD)',
    date: 'May 2024 - Aug 2024',
    desc: 'Analyzed street space quality data across ASEAN using Python libraries (pandas, geopandas, seaborn) to visualize pedestrian accessibility and urban mobility. Designed an interactive dashboard with Streamlit and Bootstrap to present complex data insights to non-technical stakeholders. Implemented cutting-edge AI models (RAG, Ollama Llama 3, Gemini 1.0 Pro) to extract and analyze large datasets, offering key insights into urban planning challenges.',
    skills: ['Python', 'Data Analysis', 'Streamlit', 'Bootstrap', 'AI', 'Backend Integration'],
  },
  {
    id: 5,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmSLZ1UMAEnnc8atxDhnh4NJ582K9pz5yXbcpgHzMnM7P2',
    role: 'Teaching Assistant & Grader @ Compact Modelling & Analysis (Calculus 2)',
    company: 'Singapore University of Technology and Design (SUTD)',
    date: 'Mar 2024 - Apr 2024',
    desc: 'Supported the instruction of Calculus 2 for 26 students by organizing supplementary meetings to address learning gaps and reinforce key concepts. Took a proactive approach to grading, ensuring assessments were completed promptly to provide immediate feedback, helping students stay focused and on track with their learning. Facilitated 20 additional tutorial sessions, helping students improve their understanding and retention of advanced mathematical topics.',
    skills: ['Higher Education Teaching', 'Peer Tutoring', 'Grading', 'Analytical Thinking'],
  },
  {
    id: 6,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmeBAwUZj2YCdeNASV3gW3t1zjhQrHpiL9N3NEM2SHjT48',
    role: 'Co-Founder, Chief Academic Officer & Strategic Advisor',
    company: 'Chicken Minds (Self-employed)',
    date: 'Jun 2021 - May 2023',
    desc: 'Led a 116-member volunteer team from prestigious Vietnamese schools to provide specialized educational programs for over 300 9th-grade students. Oversaw the development and execution of over 250 academic lesson plans across multiple subjects (Math, Literature, English, Chemistry, Physics), preparing students for entry into top high schools. Facilitated high school admissions for over 200 students, with 30% gaining admission to programs for The Gifted Students.',
    skills: [
      'Leadership',
      'Project Management',
      'Strategic Planning',
      'Team Management',
      'Curriculum Design',
    ],
    doc: 'https://www.facebook.com/ChickenMinds',
  },
];

export const education = [
  {
    id: 0,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmSLZ1UMAEnnc8atxDhnh4NJ582K9pz5yXbcpgHzMnM7P2',
    school: 'Singapore University of Technology and Design (SUTD)',
    date: 'Sep 2023 - May 2027',
    grade: '4.74 / 5.0',
    desc: 'Pursuing a Bachelor of Engineering in Computer Science and Design with a Minor in Artificial Intelligence at the Singapore University of Technology and Design (SUTD). DBS-SUTD Distinguished Scholar for AY2026/27 and Wilmar-SUTD Scholar for AY2024/25-AY2025/26. Honours List recipient across Freshmore, Sophomore, and Junior terms with a CGPA of 4.74/5.0. Relevant coursework includes Data Structures & Algorithms, Database Systems, Operating Systems & Networks, and Deep Learning.',
    degree:
      'Bachelor of Engineering - BE, Computer Science & Design (Minor in Artificial Intelligence)',
  },
  {
    id: 1,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmZsi6pjjwqipgUTujNBrFLwCxBNavKCZash9gG23KtFb7',
    school: 'Institut Teknologi Sepuluh Nopember (ITS)',
    date: 'Jun 2024 - Jul 2024',
    grade: '',
    desc: 'Completed a one-week immersive program on sustainability in Surabaya, Indonesia. Conducted data-driven analysis of willingness to pay for the Suroboyo Bus system, using statistical tools on survey data from 2,292 participants. Proposed pricing models to support fare-based sustainability.',
    degree: 'Short-Term Program in Modelling and Uncertainty (Probability & Statistics)',
  },
  {
    id: 2,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmSMXZk2hzL3zwTVwuYgWqPXVoqgyLTstGLGKRyE3dN1yJ',
    school: 'Le Hong Phong High School For The Gifted, HCMC, Vietnam',
    date: 'Sep 2020 - May 2023',
    grade: 'Honours Physics (9.3 / 10.0)',
    desc: 'Graduated with honors in Specialized Physics. Class Monitor for 2.5 years and co-founder of Chicken Minds, an education initiative for 300+ students. Member of the Football Club, winning gold and bronze medals in school and district tournaments. Recipient of the Gifted Schools Tuition Scholarship.',
    degree: 'High School Diploma, Specialized Physics',
  },
  {
    id: 3,
    img: 'https://strong-magenta-monkey.myfilebase.com/ipfs/QmYNwn6hYaFkoCNezJNkX15RH4KqMFbBZapFyUibkjUsr6',
    school: 'Tran Quoc Toan 1 Secondary School',
    date: 'Sep 2016 - May 2020',
    grade: '9.5 / 10.0',
    desc: 'Graduated as Valedictorian with a perfect math score in the HCMC High School Entrance Exam (Top 408 of ~82,300). Class Monitor for 4 years, active in STEM and charity initiatives, and football team member. Winner of district and city-level Youth Talent IT competitions.',
    degree: 'Secondary School Diploma, Vietnam Secondary School Curriculum',
  },
];

export const projects = [
  {
    id: 0,
    title: 'Deep-Credit',
    date: 'Mar 2026 - Apr 2026',
    description:
      'A credit card fraud detection project built on severely imbalanced transaction data. Engineered a preprocessing pipeline with Bayesian-smoothed target encoding, personal spending baselines, cyclical time features, and chronological train/validation/test splits. Implemented config-driven Residual MLP and FT-Transformer architectures with reusable PyTorch training, evaluation, artifact-management, and reproducibility workflows. Achieved 0.734 test PR-AUC with an Optuna-tuned Residual MLP, outperforming the strongest LightGBM baseline by 37%.',
    image: './project-images/deep-credit-cover.webp',
    tags: [
      'Python',
      'PyTorch',
      'Optuna',
      'Machine Learning',
      'Fraud Detection',
      'Data Preprocessing',
      'Residual MLP',
      'FT-Transformer',
    ],
    category: 'ml_projects',
  },
  {
    id: 10,
    title: 'Retro-Vision',
    date: 'Mar 2026 - Apr 2026',
    description:
      'A dependency-free ASCII video engine written in C. Built a media-processing pipeline that parses JSON configuration, PCM WAV audio, and BMP frames into time-synchronized ASCII video and process logs. Designed a finite-state processing engine for frame sequencing, audio-window alignment, amplitude-based highlighting, rendering, and typed failure handling. Hardened ingestion with signature, schema, and range validation plus regression tests, maintaining warning-free builds under -Wall -Werror -ansi -pedantic.',
    image: './project-images/retro-vision-cover.webp',
    tags: ['C', 'Make', 'JSON', 'PCM WAV', 'BMP', 'Finite-State Machines', 'Regression Testing'],
    category: 'other',
  },
  {
    id: 1,
    title: 'Smart Health',
    date: 'Jan 2025 - Present',
    description:
      'A full-stack Android-based health tracking application designed to help users monitor their wellness routines including medication, nutrition, and recovery. Contributed primarily to backend engineering, building 31+ secure REST APIs using Spring Boot and Spring Security, with JWT-based authentication. Set up scalable infrastructure using Render, AWS RDS (PostgreSQL), and AWS S3. Supported chatbot integration (OpenAI) and codebase modularization to improve system maintainability and integration.',
    image: './project-images/smart-health-cover.webp',
    tags: [
      'Spring Boot',
      'Spring Security',
      'JWT',
      'PostgreSQL',
      'AWS RDS',
      'AWS S3',
      'REST APIs',
      'Java',
      'Android',
      'OAuth2',
    ],
    category: 'mobile_apps',
    github: 'https://github.com/TristanNguyen04/SmartHealth-backend',
  },
  {
    id: 2,
    title: 'StayEase',
    date: 'May 2025 - Aug 2025',
    description:
      'A full‑stack hotel booking platform with a React + Vite frontend and an Express + Prisma backend on PostgreSQL. Includes user registration with email verification, JWT-based auth (token kept in cookies on the client), hotel search and details, Stripe Checkout payments, and booking history.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/C4T6-HotelBooking/refs/heads/main/docs/homescreen.png',
    tags: [
      'TypeScript',
      'Node.js',
      'Express.js',
      'React',
      'PostgreSQL',
      'Prisma ORM',
      'Jest',
      'Supertest',
      'Cypress',
      'SMTP Nodemailer',
    ],
    category: 'web_dev',
    github: 'https://github.com/TristanNguyen04/C4T6-HotelBooking',
  },
  {
    id: 3,
    title: 'VirusTotal File Scanner',
    date: 'Apr 2025',
    description:
      'A web application for scanning uploaded files using the VirusTotal API. Built with Go for the backend and HTML/CSS/JS for the frontend. Supports drag-and-drop uploads, async polling for scan results, and EC2 deployment.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/virustotal-filescanner/refs/heads/main/public/virustotal-filescanner-webpage.png',
    tags: ['Go', 'HTML', 'CSS', 'JavaScript', 'AWS EC2', 'VirusTotal API', 'Git', 'dotenv'],
    category: 'web_dev',
    github: 'https://github.com/TristanNguyen04/virustotal-filescanner',
  },
  {
    id: 4,
    title: '"Digital" Fridge Web App',
    date: 'Dec 2024',
    description:
      'An AI-powered smart fridge web application developed during the SUTD What The Hack 2024. Built robust backend logic using Flask and Flask-SQLAlchemy to manage food inventory and recipe recommendations. Implemented Gemini API chatbot for personalized cooking tips. Integrated smart notification and expiry tracking systems that improve food utilization efficiency.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/Digital-Fridge-HOTZZZZ--WTH2024/refs/heads/main/public/landing-page-screenshot.png',
    tags: [
      'Flask',
      'Python',
      'SQLite',
      'Flask-SQLAlchemy',
      'Google Gemini',
      'Bootstrap',
      'API Development',
    ],
    category: 'web_dev',
    github: 'https://github.com/TristanNguyen04/Digital-Fridge-HOTZZZZ--WTH2024',
  },
  {
    id: 5,
    title: 'AgriPredict Vietnam',
    date: 'Sep 2024 - Dec 2024',
    description:
      'A scalable food production predictor built for smallholder farmers. Developed RESTful backend with Flask and SQLite for real-time crop disease predictions. Integrated external weather and remote sensing APIs. Backend optimization efforts improved response time by 40%, aiding over 1,000 farmers in managing disease outbreaks.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/AgriPredict-Vietnam/refs/heads/main/public/home_page.png',
    tags: [
      'Flask',
      'SQLite',
      'Python',
      'REST APIs',
      'OpenWeatherMap API',
      'Data Visualization',
      'Bootstrap',
    ],
    category: 'web_dev',
    github: 'https://github.com/TristanNguyen04/AgriPredict-Vietnam',
  },
  {
    id: 6,
    title: 'Pools of Possibilities',
    date: 'Jan 2024 - May 2024',
    description:
      'An interactive installation built using motion capture (MoCap) and real-time web technologies. Developed a cloud-based system for real-time user interaction and backend integration of user-generated fish models. Enabled dynamic fish movement using ML and Boids simulation in Blender. Supported data sync via Firebase.',
    image:
      'https://static.wixstatic.com/media/166d8d_1e1929b4ab27458f9e7f0101275ad89cf000.jpg/v1/fill/w_543,h_337,al_c,q_80,usm_0.33_1.00_0.00,enc_avif,quality_auto/166d8d_1e1929b4ab27458f9e7f0101275ad89cf000.jpg',
    tags: [
      'Firebase',
      'Python',
      'JavaScript',
      'Computer Vision',
      'Cloud Firestore',
      'Machine Learning',
      'Blender',
    ],
    category: 'web_dev',
    github: 'https://github.com/TristanNguyen04/Fishing-Drawing-Website-for-Simulation',
  },
  {
    id: 7,
    title: 'Illuminating Engagement Analysis',
    date: 'Mar 2024 - Apr 2024',
    description:
      'Designed a machine learning backend system to predict user engagement based on lighting conditions. Collected and processed over 10,000 environmental datapoints. Improved prediction accuracy by 15%. Provided backend support for model training and proposed future extensions using enhanced datasets.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/Illuminating-Engagement-Analysis/main/F05_TEAM08_MSS_page-0001.jpg',
    tags: ['Python', 'Machine Learning', 'Data Analysis', 'Lighting Systems', 'Report Writing'],
    category: 'ml_projects',
    github: 'https://github.com/TristanNguyen04/Illuminating-Engagement-Analysis',
  },
  {
    id: 8,
    title: 'Miami Sea Level Rise Prediction',
    date: 'Jan 2024 - Mar 2024',
    description:
      'Built a deep learning neural network to predict future sea level rise in Miami using historical climate data (temperature, CO₂, ice coverage). Developed backend model pipeline with data ingestion, cleaning, training, and result visualization. Achieved 96% accuracy, with MAE of 0.033.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/Miami-Sea-Level-Rise-Analysis/refs/heads/main/miami-measurement.png',
    tags: ['Python', 'Neural Networks', 'Deep Learning', 'Data Science', 'Anaconda'],
    category: 'ml_projects',
    github: 'https://github.com/TristanNguyen04/Miami-Sea-Level-Rise-Analysis',
  },
  {
    id: 9,
    title: 'Mathematical Massacre Game',
    date: 'Oct 2023 - Dec 2023',
    description:
      'Developed an educational Python-based game that teaches children prime numbers. Engineered backend logic using data structures and algorithms (e.g., Sieve of Eratosthenes) for real-time gameplay. Collected and incorporated feedback from 22 children to improve learning engagement.',
    image:
      'https://raw.githubusercontent.com/TristanNguyen04/Mathematical-Massacre-Game/refs/heads/main/gameplay-screen.png',
    tags: ['Python', 'Tkinter', 'Canvas', 'OOP', 'Algorithms'],
    category: 'other',
    github: 'https://github.com/TristanNguyen04/Mathematical-Massacre-Game',
  },
];
